module.exports = __webpack_public_path__ + "static/media/Social-Media-Icons.c6cb7a74.svg";